function Top()
{
    return (
        <>
        <div className='top'>
        <div id='title'>카드 뒤집기 게임</div>
        </div>
        </>
    );
}

export default Top;